import { useEffect, useMemo } from "react";
import { matchRoutes, useLocation } from "react-router";

import { appRoutes } from "./routeConfig";

export type AppRouteHandle = {
  title?: string;
};

import { APP_NAME } from "@/constants/site";

function getPageTitle(pathname: string): string | undefined {
  const matches = matchRoutes(appRoutes, pathname);
  if (!matches?.length) return undefined;

  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const handle = matches[i]?.route.handle as AppRouteHandle | undefined;
    if (handle?.title) return handle.title;
  }
  return undefined;
}

/**
 * 随当前路由更新浏览器标签标题（需在 BrowserRouter / Router 内渲染）。
 */
export function DocumentTitle() {
  const { pathname } = useLocation();
  const pageTitle = useMemo(() => getPageTitle(pathname), [pathname]);

  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} · ${APP_NAME}` : APP_NAME;
  }, [pageTitle]);

  return null;
}
